export default __webpack_public_path__ + "static/media/roboto-bold-webfont.4fd18de3.woff2";